/**
 * Check if the currently logged-in user is an admin.
 * Used to grant admin-only access (e.g., Sunday event testing).
 */
import api from '../services/api';

export function isCurrentUserAdmin() {
  const user = api.getUser();
  if (!user) return false;
  return !!(user.is_staff || user.is_superuser || user.role === 'ADMIN' || user.role === 'superadmin');
}

export function isCurrentUserStrictAdmin() {
  const user = api.getUser();
  if (!user) return false;
  const role = String(user.role || '').trim().toLowerCase();
  return !!(
    user.is_superuser ||
    role === 'admin' ||
    role === 'superadmin'
  );
}
